export const CACHE_KEY_LIST_PROPOSAL_REQUEST = 'proposalRequests';
export const CACHE_KEY_LIST_OLD_PROPOSAL_REQUEST = 'old-proposalRequests';
export const CACHE_KEY_PROPOSAL_REQUEST = 'proposalRequest-one';
export const ROUTE_USER_PATH_PROPOSAL_REQUEST = '/proposal';
export const ROUTE_USER_PATH__NEW_PROPOSAL_REQUEST = '/new-proposal';
export const ROUTE_USER_PATH_COMPANY = '/company';
export const ROUTE_PATH_PROPOSAL_REQUEST = '/proposal-request/requests';
export const TRANSLATION_PREFIX_PROPOSAL_REQUEST = 'proposalRequest';
export const SECURITY_KEY_PROPOSAL_REQUEST = 'REQUEST';

export const CACHE_KEY_LIST_HISTORY_PROPOSAL_REQUEST = 'proposalRequestsHistory';

export const CACHE_KEY_LIST_COMMENTS_PROPOSAL_REQUEST = 'proposalRequestsComments';
export const CACHE_KEY_LIST_COMMENTS_REPLY_PROPOSAL_REQUEST = 'proposalRequestsCommentsReply';
export const CACHE_KEY_COMMENTS_PROPOSAL_REQUEST = 'proposalRequestsComments-one';

export const DIALOG_PARTNER_NAMESPACE = 'new-partner-dialog';
export const DIALOG_STATE_PARTNER_NAMESPACE = 'new-state-partner-dialog';
export const DIALOG_GENERAL_PARTNER_NAMESPACE = 'new-general-partner-dialog';
export const DIALOG_ADMIN_GENERAL_PARTNER_NAMESPACE = 'new-administration-partner-dialog';
export const DIALOG_CONTROL_GENERAL_PARTNER_NAMESPACE = 'new-control-partner-dialog';

export const DIALOG_STATUS_REASON_NAMESPACE = 'new-state-reason-dialog';

export const PROPOSAL_REQUEST_STEPS = [
  {title: 'steps.request', key: 'request'},
  {title: 'steps.partners', key: 'partners'},
  {title: 'steps.organizations', key: 'organizations'},
  {title: 'steps.summary', key: 'summary'},
];

export const TCP_PROPOSAL_REQUEST_STEPS = [
  {title: 'steps.request', key: 'request'},
  {title: 'steps.partnersTCP', key: 'partners'},
  {title: 'steps.permissions', key: 'permissions'},
  {title: 'steps.summary', key: 'summary'},
];

export const PROPOSAL_REQUEST_STEPS_SECURITY = [
  {title: 'steps.personal', key: 'personal',},
].concat(PROPOSAL_REQUEST_STEPS.filter(e => ['request', 'partners', 'summary'].includes(e?.key)));

export const PROPOSAL_SUBJECT_TYPE_APPEARANCE = {
  STATE_MIPYME: {color: '#965AFF'},
  PRIVATE_MIPYME: {color: '#17AB70'},
  ORGANIZATION_PMS: {color: '#ed8834'},
  CNA: {color: '#338DC8'},
  TCP_PROPOSAL: {color: '#c83356'}
};

export const PROPOSAL_SUBJECT_EXTENDED = {
  MIPYMES: 'MIPYMES',
};

export const MODELS_FILE_KEYS = {
  MODELO_CARTA_SOCIO_DESIGNADO: 'mp-socio-designado',
  CNA_PARTNERS: 'cna-partners',
  MIPYMES_STATUTES: 'mp-estatutos',
  CNA_STATUTES: 'cna-estatutos',
  COMPANY_LIQUIDATION_BALANCE: 'company-liquidation-balance',
  PARTNERS_VERIFICATION: 'partners-verification',
  MODELO_CAMBIO_DENOMINACION_CAMBIO_DOMICILIO_CAMBIO_DE_OBJETO_INCREMENTO: 'modelo-cambio-domicilio-cambio-de-objeto-incremento',
  MODELO_CAMBIOS_DE_CARGOS_DE_ORGANOS_SOCIALES_PARA_ELEVAR_A_PUBLICO: 'modelo-cambios-de-cargos-de-organos-sociales-para-elevar-a-publico',
  MODELO_INCORPORACION_DE_SOCIOS_POR_NUEVAS_APORTACIONES_QUE_CREAN: 'modelo-incorporacion-de-socios-por-nuevas-aportaciones-que-crean',
  MODELO_OTROS_TRAMITES_NOTARIALES_PROTOCOLIZACION_DE_BALANCES_Y_OPERATORIA: 'modelo-otros-tramites-notariales-protocolizacion-de-balances-y-operatoria',
  MODELO_PARA_CEDER_PARTICIPACIONES: 'modelo-para-ceder-participaciones',
  MODELO_LICENCIA_AGENTE_SEGURO: 'modelo-licencia-agente-seguro',
};

export const DENOMINATION_TYPES = {
  baseSRL: 'S.R.L',
  SRL: 'S.R.L.',
  SURL: 'S.U.R.L.',
  baseSURL: 'S.U.R.L.',
};
